module.exports = ".container.col-lg-11 {\n  min-height: 80vh;\n}\n\n\n.btn-disabled:hover{\n  cursor: not-allowed !important;\n}\n\n\n.custom-card-title{\n  font-size:2rem;\n}\n\n\n.custom-card-title:after{\n  content:'';\n  display:block;\n  background-color: #bbdefb;\n  height:3px;\n  width:80px;\n  margin:10px 0 40px;\n}\n\n\nnavbar, .site-navbar{\n  z-index:999 !important;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/styles.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/styles.css
// module chunks = styles